import qs from 'query-string'
import forOwn from 'lodash/forOwn'

export type ChampionColumnFilterRule = {
  column: string
  operator: string
  operand: unknown
}

export const buildChampionColumnFiltersParam = (search: string): string | undefined => {
  const query = qs.parse(search, { arrayFormat: 'bracket' })
  const rules: ChampionColumnFilterRule[] = []

  forOwn(query, (value: unknown, key: string) => {
    if (!key.includes(':')) {
      return
    }
    const [column, operator] = key.split(':')
    if (!column || !operator) {
      return
    }

    let operand: unknown = value
    if (typeof value === 'string') {
      try {
        operand = JSON.parse(value)
      } catch {
        operand = value
      }
    }

    rules.push({ column, operator, operand })
  })

  return rules.length ? JSON.stringify(rules) : undefined
}
